import { Component, Input, Output, EventEmitter, OnInit, AfterViewInit, OnChanges, SimpleChanges, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { Globals } from '../../globals/globals';
import { GlobalClickService } from '../../services/global-click/global-click.service';
/* import * as _ from 'lodash'; */
declare var $: any;

export class ColumnConfiguration {
  colname?: string;
  width?: number;
  sizable?: boolean;
}

export class Autocomplete {
  field?: string;
  object?: string;
}

export class SelectOption {
  value!: any;
  text!: any;
  isDefault?: boolean;
}

@Component({
  selector: 'teiasoft-input',
  templateUrl: './teiasoft-input.component.html',
  styleUrls: ['./teiasoft-input.component.scss']
})

export class TeiasoftInputComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  @Input() value: any;
  @Input() type: string = 'text';
  @Input() labelText: string = "";
  @Input() isRequired: boolean = false;
  @Input() placeHolder: string = "";
  @Input() isValid: boolean = true;
  @Input() disabled: boolean = false;
  @Input() isMobile: boolean = false;
  @Input() selectOptions: SelectOption[] = new Array();
  @Input() noMargin: boolean = false;
  @Input() noMinWidth: boolean = false;
  @Input() size: string = "";
  @Input() clearValue: boolean = false;
  @Input() autoCompleteField: string = "";
  @Input() autoComplete: boolean = false;
  @Input() autoCompleteDataset: any[] = new Array();
  @Input() autoCompleteColumns: string[] = new Array();
  @Input() autoCompleteColumnsToHide: string[] = new Array();
  @Input() autoCompletePosition: string = 'fixed';
  @Input() columnsWidthPerc: number[] = new Array();
  @Input() showCreate: boolean = false;
  @Input() anchor?: string = "left";
  @Input() selectable?: boolean = false;
  @Input() multiSelection?: boolean = false;
  @Input() readOnly: boolean = false;
  @Input() tabIndex: number = 0;
  @Input() maxLength: number = 524288; // Default max Length
  @Input() chipsContainerViewHeight: number = 4.9;
  @Input() allowNegative: boolean = true; // to allow/prevent negative values on numeric input
  @Input() startIcon = "";
  @Input() isMultiOperator: boolean = false;
  @Input() hasUoms: boolean = false;
  @Input() uomOptionList: SelectOption[] = new Array();
  @Input() roundDigits: number = 2;
  @Input() limitDecimalDigits: boolean = false;
  @Input() allowSingleSelectionClear: boolean = false;
  @Input() hideLabel: boolean = false;
  @Input() defaultQueryDirection: string = '';
  @Input() preserveFocusOnAutocompleteSelection: boolean = false;

  @Output() onInput: EventEmitter<any> = new EventEmitter();
  @Output() onKeyUp: EventEmitter<any> = new EventEmitter();
  @Output() onAutocompleteSelect: EventEmitter<Autocomplete> = new EventEmitter();
  @Output() onAutocompleteSelectRows: EventEmitter<Autocomplete> = new EventEmitter();
  @Output() onAutocompleteLinkClick: EventEmitter<string> = new EventEmitter();
  @Output() onAutocompleteInputChange: EventEmitter<Autocomplete> = new EventEmitter();
  @Output() onAutocompleteRemoveElement: EventEmitter<Autocomplete> = new EventEmitter();

  @Output() selectChange: EventEmitter<any> = new EventEmitter();
  @Output() selectedUomChange: EventEmitter<any> = new EventEmitter();

  @ViewChild('inputWrapper') inputWrapper!: ElementRef;
  optionsW: number = 0;
  optionsTop: number = 0;
  optionsLeft: number = 0;
  autoCompleteContentWidth: number = 0;


  showPwd: boolean = false;
  myType: string = "password";
  inputId: string = "input";
  //cntGridW?: number;
  filteredDataSet: any[] = new Array();
  autoCompleteId: string = "";
  //clearAutocompleteSelection: boolean = false; //M.M 3.01.24
  //inputValue:string = "";
  acVisible: boolean = false;
  acColumns: string[] = new Array();
  columnsConfiguration: ColumnConfiguration[] = new Array();
  selectedRows: any[] = new Array();
  preventCloseAutocomplete: boolean = false;
  hoverIndex: number = -1;
  lastValidValue: string = '';
  selQueryDirection: string = "";
  betweenToEmit: string = "";
  value1: any = '';
  value2: any = '';
  selectedUom: string = "";
  hasUserSelectedUom: boolean = false;
  imWriting: boolean = false;

  clickListener!: (evt: any) => void;

  constructor(public globals: Globals, private globalClickService: GlobalClickService) {


    /* if (document.getElementById("teiasoftDialog") && !this.globals.inputHasEvents){
        this.globals.inputHasEvents = true;
        document.getElementById("teiasoftDialog")!.addEventListener('keydown', (evt: any) =>  this.closeAllAutolistOpened(evt), true); 
        document.getElementById("teiasoftDialog")!.addEventListener('click', (evt: any) =>  this.closeAllAutolistOpened(evt), true); 
    }

    if (document.getElementById("teiasoftDialogItem") && !this.globals.inputHasEvents){
      this.globals.inputHasEvents = true;
      document.getElementById("teiasoftDialogItem")!.addEventListener('keydown', (evt: any) =>  this.closeAllAutolistOpened(evt), true); 
      document.getElementById("teiasoftDialogItem")!.addEventListener('click', (evt: any) =>  this.closeAllAutolistOpened(evt), true); 
    } */
  }

  ngOnInit(): void {
    this.generateId();

    if (this.isMultiOperator && !this.selQueryDirection && this.defaultQueryDirection) {
      this.selQueryDirection = this.defaultQueryDirection;
    }
    this.ensureDefaultUomSelection();

    // Initialize lastValidValue for numeric input with the current input value
    if (this.type == 'number' && this.isValidNumberInput(this.value)) {
      this.value = this.getValueWithRoudDigits(this.value);
      this.lastValidValue = this.value;
    }

    this.globalClickService.registerComponent(this);

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes["selectOptions"]) {
      this.selectOptions = new Array();
      this.selectOptions = changes["selectOptions"].currentValue;
    }

    if (changes && changes["value"]) {
      this.value = changes["value"].currentValue;
      if(this.autoCompleteDataset && this.multiSelection && this.value.length == 0){
        this.selectedRows = new Array(); // if autocomplete receive empty value, remove previously selcted rows
      }
    }

    if (changes && changes["uomOptionList"]) {
      this.uomOptionList = new Array();
      this.uomOptionList = changes["uomOptionList"].currentValue;
      this.ensureDefaultUomSelection();
    }

    if (changes && changes["tabIndex"]) {
      this.tabIndex = changes["tabIndex"].currentValue;
    }

    if (changes && changes["hasUoms"]) {
      this.hasUoms = changes["hasUoms"].currentValue;
      this.ensureDefaultUomSelection();
    }

    if (changes && changes["maxLength"]) {
      if (changes["maxLength"].currentValue != null && changes["maxLength"].currentValue != undefined)
        this.maxLength = changes["maxLength"].currentValue;
    }

    if (changes && changes["isValid"]) {
      this.isValid = changes["isValid"].currentValue;
    }

    if (changes && changes["isMultiOperator"]) {
      this.isMultiOperator = changes["isMultiOperator"].currentValue;
      if (this.isMultiOperator && !this.selQueryDirection && this.defaultQueryDirection) {
        this.selQueryDirection = this.defaultQueryDirection;
      }
    }

    if (changes && changes["defaultQueryDirection"]) {
      this.defaultQueryDirection = changes["defaultQueryDirection"].currentValue;
      if (this.isMultiOperator && !this.selQueryDirection && this.defaultQueryDirection) {
        this.selQueryDirection = this.defaultQueryDirection;
      }
    }

    if (changes && changes["roundDigits"]) {
      this.roundDigits = changes["roundDigits"].currentValue;
      /* let _elem: any = document.getElementById(this.inputId)!;
      if (_elem){
        if (!this.isValidNumberInput(_elem["value"])){
          _elem["value"] = parseFloat(this.value).toFixed(this.roundDigits);
          this.value = _elem["value"];
        }
      } */
    }

    if (changes && changes["clearValue"]) {
      this.clearValue = changes["clearValue"].currentValue;
      if (this.clearValue) {
        this.selQueryDirection = this.isMultiOperator ? (this.defaultQueryDirection || '') : '';
        let _elem: any = document.getElementById(this.inputId)!;
        if (_elem) {
          _elem["value"] = '';
          this.value = '';
          this.value1 = '';
          this.value2 = '';
          //this.inputValue = '';
        }
        this.selectedUom = '';
        this.hasUserSelectedUom = false;
      } else {
        this.ensureDefaultUomSelection();
      }
    }

    if (changes && changes["autoCompleteDataset"]) {
      this.autoCompleteDataset = new Array();
      this.autoCompleteDataset = changes["autoCompleteDataset"].currentValue;
      this.setColumns();
      this.setDimensions();
      /* if (changes["autoCompleteDataset"].firstChange) this.setPreselectRows(); */
      this.setPreselectRows();
      if (this.autoComplete && !this.multiSelection) {
        this.checkValueInAutocompleteList();
      }
      if (this.autoCompleteDataset && this.autoCompleteDataset.length == 0) {
        this.hoverIndex = -1; // GBR MQBF-24
      } else {

      }
    }

    if (changes && changes["autoCompleteColumns"]) {
      this.autoCompleteColumns = new Array();
      this.autoCompleteColumns = changes["autoCompleteColumns"].currentValue;
      this.setColumns();
    }

    if (changes && changes["autoCompleteColumnsToHide"]) {
      this.autoCompleteColumnsToHide = new Array();
      this.autoCompleteColumnsToHide = changes["autoCompleteColumnsToHide"].currentValue;
      this.setColumns();
    }

    if (changes && changes["anchor"]) {
      this.anchor = changes["anchor"].currentValue;
    }

    if (changes && changes["showCreate"]) {
      this.showCreate = changes["showCreate"].currentValue;
    }

    if (changes && changes["type"]) {
      this.type = changes["type"].currentValue;
    }

    // 
    if (this.value == undefined) this.value = "";
  }

  ngOnDestroy(): void {
    // document.body.removeEventListener('click', this.clickListener, true);
    this.globalClickService.unregisterComponent(this);
    this.removeIdFromSessionStorage("TI-INPUT-LIST", this.inputId);
    this.removeIdFromSessionStorage("TI-AUTOCOMPLETE-LIST", this.autoCompleteId);
  }

  handleClickOutside(event: Event) {
    if (this.autoCompleteId == "") return;
    let _className: string = (event.target as HTMLElement).className!;
    if ((event.target as HTMLElement).closest(`#${this.autoCompleteId}`) == null) {
      this.hideAutocomplete();
    }
  }

  ngAfterViewInit(): void {
    if (document.getElementById("teiasoftDialog") && !this.globals.inputHasEvents) {
      this.globals.inputHasEvents = true;
      document.getElementById("teiasoftDialog")!.addEventListener('keydown', (evt: any) => this.closeAllAutolistOpened(evt), true);
      document.getElementById("teiasoftDialog")!.addEventListener('click', (evt: any) => this.closeAllAutolistOpened(evt), true);
    }

    if (document.getElementById("teiasoftDialogItem") && !this.globals.inputHasEvents) {
      this.globals.inputHasEvents = true;
      document.getElementById("teiasoftDialogItem")!.addEventListener('keydown', (evt: any) => this.closeAllAutolistOpened(evt), true);
      document.getElementById("teiasoftDialogItem")!.addEventListener('click', (evt: any) => this.closeAllAutolistOpened(evt), true);
    }

    // INPUT PWD
    if (this.type == 'password') {
      let _elem: any = document.getElementById("inputPwd");
      let _cnt: any = document.getElementById("inputPwdCnt");
      _elem.addEventListener("focusin", (event: any) => {
        if (!this.isMobile) {
          _cnt.classList.add("ti-pwd-cnt-focus");
        }
        else {
          _cnt.classList.add("ti-pwd-cnt-focus-mobile");
        }
      });

      _elem.addEventListener("focusout", (event: any) => {
        if (!this.isMobile) {
          _cnt.classList.remove("ti-pwd-cnt-focus");
        }
        else {
          _cnt.classList.remove("ti-pwd-cnt-focus-mobile");
        }
      });
    }
    setTimeout(() => {
      this.setDimensions();
      this.openAutocompleteOnInit();
    }, 250);
  }


  /************************************************** METHODS ********************************************************/
  closeAllAutolistOpened(evt: any) {
    if (evt.code == 'Tab') {
      this.hideAllAutocomplete();
    }
    //  else {
    //   //console.log(evt["target"]["className"]);
    //   let _class:string = evt["target"]["className"];
    //   _class = _class.replace(" ng-star-inserted", "");
    //   if (_class.indexOf('fal fa-angle-up ts-ico') == -1 && _class != 'ti-chips-cnt' && _class != 'fal fa-times-circle ts-ico' && _class.indexOf('fal fa-crosshairs') == -1 && _class != 'ac-cell'
    //     && _class.indexOf('ac-cell-span') == -1 && _class != 'tc-chip' && _class != 'tc-span' && _class != 'fal fa-times tc-icon' && _class != 'ti-input-ac'){
    //     this.hideAllAutocomplete();
    //   }
    // } 
  }

  /**
   * IF IS IN CREATE MODE THAN OPEN THE AUTOCO
   */
  openAutocompleteOnInit() {
    if (this.tabIndex == 1 && this.autoComplete && !this.multiSelection && this.value == '') {
      this.onAutocompleteIcoClick('');
      this.hoverIndex = -1;
    }
  }

  checkValueInAutocompleteList() {
    if (this.value == '') return;
    if (!this.autoCompleteDataset || this.autoCompleteDataset.length == 0) return;
    let _foundIt: boolean = false;
    for (var x = 0; x < this.autoCompleteDataset.length; x++) {
      for (const prop in this.autoCompleteDataset[x]) {
        if (this.autoCompleteDataset[x][prop] == this.value) {
          _foundIt = true;
          break;
        }
      }
      if (_foundIt) break;
    }

    if (_foundIt == false) {
      // Se non ho trovato il valore nel dataset allora svuoto il value e la selectedRows
      this.value = null;
      this.selectedRows = new Array()
    }
  }

  generateId() {
    let _list: string[] = new Array();
    if (sessionStorage.getItem("TI-INPUT-LIST")) {
      _list = sessionStorage.getItem("TI-INPUT-LIST")!.split(",");
      if (_list.length == 999999) {
        _list = new Array();
        sessionStorage.removeItem("TI-INPUT-LIST");
      }
    }
    let x = this.getRandomInt(0, 999999);
    if (_list && _list.length > 0) {
      while (_list.findIndex(t => t == "TI_" + x.toString()) != -1) {
        let x = this.getRandomInt(0, 999999);
        if (_list.findIndex(t => t == "TI_" + x.toString()) == -1) break;
      }
    } else {
      _list = new Array();
    }
    _list.push("TI_" + x.toString());
    sessionStorage.setItem("TI-INPUT-LIST", _list.join(","));
    this.inputId = "TI_" + x.toString();

    if (this.autoComplete) this.generateAutoCompleteId();
  }

  generateAutoCompleteId() {
    let _list: string[] = new Array();
    if (sessionStorage.getItem("TI-AUTOCOMPLETE-LIST")) {
      _list = sessionStorage.getItem("TI-AUTOCOMPLETE-LIST")!.split(",");
      if (_list.length == 999999) {
        _list = new Array();
        sessionStorage.removeItem("TI-AUTOCOMPLETE-LIST");
      }
    }
    let x = this.getRandomInt(0, 999999);
    if (_list && _list.length > 0) {
      while (_list.findIndex(t => t == "TIAC_" + x.toString()) != -1) {
        let x = this.getRandomInt(0, 999999);
        if (_list.findIndex(t => t == "TIAC_" + x.toString()) == -1) break;
      }
    } else {
      _list = new Array();
    }
    _list.push("TIAC_" + x.toString());
    sessionStorage.setItem("TI-AUTOCOMPLETE-LIST", _list.join(","));
    this.autoCompleteId = "TIAC_" + x.toString();
  }

  getRandomInt(min: number, max: number): number {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  private removeIdFromSessionStorage(storageKey: string, id: string): void {
    if (!id) {
      return;
    }

    const stored = sessionStorage.getItem(storageKey);
    if (!stored) {
      return;
    }

    const updated = stored.split(',').filter(item => item && item !== id);
    if (updated.length > 0) {
      sessionStorage.setItem(storageKey, updated.join(','));
    } else {
      sessionStorage.removeItem(storageKey);
    }
  }

  /* SHOW HIDE/ AUTOCOMPLETE */
  showAutocomplete() {
    this.preventCloseAutocomplete = true;
    let _list: string[] = new Array();
    if (sessionStorage.getItem("TI-AUTOCOMPLETE-LIST")) {
      _list = sessionStorage.getItem("TI-AUTOCOMPLETE-LIST")!.split(",");
      for (var x = 0; x < _list.length; x++) {
        if (_list[x] != this.autoCompleteId) {
          $("#" + _list[x]).removeClass("tiac-show-me");
        }
      }
    }
    $("#" + this.autoCompleteId).addClass('tiac-show-me');
    //$("#" + this.autoCompleteId).width($('#cnt_' + this.inputId).width()-(screen.width*0.007));
    // $("#" + this.autoCompleteId).width($('#cnt_' + this.inputId).width());
    const rect = this.inputWrapper.nativeElement.getBoundingClientRect();
    const computedStyle = window.getComputedStyle(this.inputWrapper.nativeElement);

    // Get the padding and border values
    const borderLeftWidth = parseFloat(computedStyle.borderLeftWidth);
    const borderRightWidth = parseFloat(computedStyle.borderRightWidth);

    // Calculate the content width (rect.width excludes margins, so no need to subtract those)
    const contentWidth = Math.max(0, rect.width - borderLeftWidth - borderRightWidth);
    const desiredWidth = Math.max(contentWidth, this.autoCompleteContentWidth);
    const viewportWidth = window.innerWidth || document.documentElement.clientWidth || screen.width || desiredWidth;
    const viewportMargin = 16;
    const viewportAvailableWidth = viewportWidth - (viewportMargin * 2);
    const maxAllowedWidth = viewportAvailableWidth > 0 ? viewportAvailableWidth : desiredWidth;

    this.optionsTop = rect.bottom; // Position below the input
    if (this.autoCompletePosition == 'fixed') {
      this.optionsW = Math.min(desiredWidth, maxAllowedWidth);
      let adjustedLeft = rect.left;
      const maxLeft = viewportWidth - viewportMargin - this.optionsW;
      if (adjustedLeft > maxLeft) {
        adjustedLeft = Math.max(viewportMargin, maxLeft);
      }
      if (adjustedLeft < viewportMargin) {
        adjustedLeft = viewportMargin;
      }
      this.optionsLeft = adjustedLeft;
    } else {
      this.optionsW = desiredWidth;
      this.optionsLeft = rect.left;  // Align to the input
    }

    this.acVisible = true;
    $("#" + this.inputId).focus();
    this.preventCloseAutocomplete = false;
  }

  hideAutocomplete() {
    /* GBR MQF-450 */
    if (this.multiSelection) {
      if ($("#" + this.inputId).val() != '') {
        $("#" + this.inputId).val('');
        let _ret: Autocomplete = new Autocomplete();
        _ret.field = this.autoCompleteField;
        _ret.object = '';
        this.onAutocompleteInputChange.emit(_ret);
      }

    };
    /* END MQF-450 */

    $("#" + this.autoCompleteId).removeClass('tiac-show-me');
    this.acVisible = false;
    this.preventCloseAutocomplete = false;
    //$('#' + this.inputId).val('');

  }

  hideAllAutocomplete() {
    let _list: string[] = new Array();
    if (sessionStorage.getItem("TI-AUTOCOMPLETE-LIST")) {
      _list = sessionStorage.getItem("TI-AUTOCOMPLETE-LIST")!.split(",");
      for (var x = 0; x < _list.length; x++) {
        $("#" + _list[x]).removeClass("tiac-show-me");
      }
    }
    this.acVisible = false;
    this.preventCloseAutocomplete = false;
  }

  imOpen(): boolean {
    if ($("#" + this.autoCompleteId).hasClass('tiac-show-me'))
      return true;
    else
      return false;
  }

  /*** END  */

  getInputAutocompleteW_DEPRECATED(): number {
    let _cntW: number = $('#cnt_' + this.inputId).width() - (screen.width * 0.014);
    if (this.showCreate) {
      return _cntW - 125;
    } else {
      return _cntW; //(screen.width*0.014);
    }

  }

  setColumns() {
    //if (!this.multiSelection) return;
    if (!this.autoCompleteColumns || this.autoCompleteColumns.length == 0) return;
    this.acColumns = new Array();
    for (var x = 0; x < this.autoCompleteColumns.length; x++) {
      let _i: number = this.autoCompleteColumnsToHide.findIndex(k => k.toLowerCase() == this.autoCompleteColumns[x].toLowerCase());
      if (_i == -1) {
        this.acColumns.push(this.autoCompleteColumns[x].substring(0, 1).toUpperCase() + this.autoCompleteColumns[x].substring(1, this.autoCompleteColumns[x].length));
      }
      //this.autoCompleteColumns[x] = this.autoCompleteColumns[x].substring(0,1).toUpperCase() + this.autoCompleteColumns[x].substring(1,this.autoCompleteColumns[x].length);
    }
  }

  getColValue(row: any, col: string): any {
    for (const key in row) {
      if (key.toLowerCase() == col.toLowerCase()) {
        return row[key];
      }
    }
    return "";
  }

  setDimensions() {
    if (!this.autoCompleteDataset || this.autoCompleteDataset.length == 0) {
      this.autoCompleteContentWidth = 0;
      return;
    }
    if (this.autoComplete && this.autoCompleteId == '') {
      this.autoCompleteContentWidth = 0;
      return;
    }
    let _gridVw = 0;
    const maxLengths: any = {};
    this.columnsConfiguration = new Array();
    // Iterate through each property in the object
    let obj: any = this.autoCompleteDataset[0];
    for (const key in obj) {
      let _i: number = this.autoCompleteColumnsToHide.findIndex(x => x.toLowerCase() == key.toLowerCase());
      if (obj.hasOwnProperty(key) && _i == -1) { /* && typeof obj[key] === "string" */
        // Store in Array the single key values
        let _list: any[] = this.autoCompleteDataset.map(x => x[key]);
        let _length: number = 0;
        if ((_list.length == 1 && _list[0] == null) || _list.every(x => x == null)) {
          _length = 10; // Default for empty colums
        } else {
          _length = _list.sort(
            function (a, b) {
              return (b != null ? b.length : 0) - (a != null ? a.length : 0);
            })[0].toString().length;
        }

        let _item: ColumnConfiguration = new ColumnConfiguration();
        _item.colname = key;
        _item.sizable = false;
        let _w: number = _length * 0.65;
        _item.width = _w < 5 ? 5 : _w
        this.columnsConfiguration.push(_item);
        _gridVw += _item.width!;
      }
    }

    // CHECK IF TOTAL IS LESS THAN MIN WIDTH
    let _cntW: number = 100; // ($("#" + this.autoCompleteId).width()*100)/screen.width;
    if (_gridVw < _cntW) {
      let _diff: number = (_cntW - _gridVw) / this.columnsConfiguration.length;
      _gridVw = 0;
      for (var x = 0; x < this.columnsConfiguration.length; x++) {
        this.columnsConfiguration[x].width! += _diff;
        _gridVw += this.columnsConfiguration[x].width!;
      }
    }

    this.autoCompleteContentWidth = this.calculateAutoCompleteContentWidth();
  }

  getColumnsWidth(col: string, cell: string): number {
    let _diff: number = 1;
    let _i: number = this.columnsConfiguration.findIndex(x => x.colname?.toLowerCase() == col.toLowerCase());
    if (_i != -1) {
      return this.columnsConfiguration[_i].width!;// - (cell == 'h' ? (_diff/this.acColumns.length) : 0);
    } else {
      return 0;
    }
  }

  private calculateAutoCompleteContentWidth(): number {
    if (!this.autoCompleteDataset || this.autoCompleteDataset.length == 0) return 0;
    if (!this.acColumns || this.acColumns.length == 0) return 0;

    const approxCharWidth = 8;
    const columnPadding = 32;
    const booleanColumnWidth = 40;

    let totalWidth = 0;

    for (const column of this.acColumns) {
      let maxCharacters = column.length;
      let hasBooleanValues = false;

      for (const row of this.autoCompleteDataset) {
        const value = this.getColValue(row, column);
        if (typeof value === 'boolean') {
          hasBooleanValues = true;
          continue;
        }
        if (value == null) continue;

        const valueLength = value.toString().length;
        if (valueLength > maxCharacters) {
          maxCharacters = valueLength;
        }
      }

      if (hasBooleanValues) {
        totalWidth += booleanColumnWidth;
      } else {
        totalWidth += (maxCharacters * approxCharWidth) + columnPadding;
      }
    }

    if (this.showCreate) {
      totalWidth += 150;
    }

    return totalWidth;
  }

  isRowSelected(evt: any): boolean {
    let _i: number = this.selectedRows.findIndex(x => JSON.stringify(x) == JSON.stringify(evt));
    if (_i == -1)
      return false;
    else
      return true;
  }

  setPreselectRows() {
    if (!this.autoCompleteDataset || this.autoCompleteDataset.length == 0) return;
    if (this.value == null || this.value.toString() == '') return;
    if (!this.selectedRows) this.selectedRows = new Array();
    if (!this.multiSelection) {
      this.fillSelectedRows(this.value);
    } else {
      let _temp: any[] = new Array();
      _temp = Array.isArray(this.value) ? this.value : this.value.toString().split(',');
      for (var x = 0; x < _temp.length; x++) {
        this.fillSelectedRows(_temp[x]);
      }
    }
  }

  fillSelectedRows(value: any) {
    for (var x = 0; x < this.autoCompleteDataset.length; x++) {
      for (const key in this.autoCompleteDataset[0]) {
        if (this.autoCompleteDataset[x][key] == value) {
          if (!this.selectedRows) this.selectedRows = new Array();
          if (this.selectedRows.findIndex(s => JSON.stringify(s) == JSON.stringify(this.autoCompleteDataset[x])) == -1)
            this.selectedRows.push(this.autoCompleteDataset[x]);
        }
      }
    }
  }

  /**
 * GET THE TYPE OF THE VALUE PRINTED ON CELL
 * @param val 
 * @returns 
 */
  getValueType(row: any, key: any): string {
    if (key == undefined) return "";
    let _val: any = row[key.substring(0, 1).toLowerCase() + key.substring(1, key.length)];
    return typeof _val;
  }

  /* EVENTS */
  onAutocompleteIcoClick(evt: any) {
    if (evt != '') {
      this.globalClickService.notifyClick(evt, this);
      evt.stopPropagation();
      evt.preventDefault();
    }
    if (this.preventCloseAutocomplete) {
      this.preventCloseAutocomplete = false;
      return;
    }
    if (this.readOnly == true) return;
    if (this.acVisible == true) {
      this.hideAutocomplete();
    } else {
      this.showAutocomplete();
    }
  }

  onKeyDown(evt: any) {
    if (evt.key == 'Tab') {
      let _list: string[] = new Array();
      if (sessionStorage.getItem("TI-AUTOCOMPLETE-LIST")) {
        _list = sessionStorage.getItem("TI-AUTOCOMPLETE-LIST")!.split(",");
        for (var x = 0; x < _list.length; x++) {
          $("#" + _list[x]).removeClass("tiac-show-me");
        }
      }
      return;
    }

    // GBR 26/02/2024 - MQBF-7
    // Arrow UP
    if (evt.keyCode == 38) {
      if (this.autoComplete && this.acVisible) {
        if (this.hoverIndex == 0) return;
        this.hoverIndex--;
        for (var x = 0; x < this.autoCompleteDataset.length; x++) {
          $('#ac_row_' + this.autoCompleteId + "_" + x).removeClass("ac-row-selected");
        }
        $('#ac_row_' + this.autoCompleteId + "_" + this.hoverIndex).addClass("ac-row-selected");

        let _scroll: number = $('#ac_cnt_' + this.autoCompleteId).scrollTop();
        let _acRowH: number = $('.ac-row').height();
        let _acCntH: number = $('#ac_cnt_' + this.autoCompleteId).height();
        if (_scroll > (_acRowH * this.hoverIndex)) {
          $('#ac_cnt_' + this.autoCompleteId).scrollTop(_scroll - Math.round(_acRowH));
        }

      }
    }

    // Arrow Down
    if (evt.keyCode == 40) {
      if (this.autoComplete && this.acVisible) {
        if (this.hoverIndex == this.autoCompleteDataset.length - 1) return;
        this.hoverIndex++;
        for (var x = 0; x < this.autoCompleteDataset.length; x++) {
          $('#ac_row_' + this.autoCompleteId + "_" + x).removeClass("ac-row-selected");
        }
        $('#ac_row_' + this.autoCompleteId + "_" + this.hoverIndex).addClass("ac-row-selected");

        let _scroll: number = $('#ac_cnt_' + this.autoCompleteId).scrollTop();
        let _acRowH: number = $('#ac_row_' + this.autoCompleteId + "_" + this.hoverIndex).height();
        let _acCntH: number = $('#ac_cnt_' + this.autoCompleteId).height();
        if (this.hoverIndex > 6) {
          $('#ac_cnt_' + this.autoCompleteId).scrollTop(Math.round(_scroll + _acRowH));
        }

      }
    }

    if (evt.keyCode == 13 && this.autoComplete && this.acVisible && this.hoverIndex > -1 && this.autoCompleteDataset[this.hoverIndex]) {
      this.rowClick(null, this.autoCompleteDataset[this.hoverIndex], true);
      //this.hoverIndex = -1;
    }
  }

  onInputFocus(evt: any) {
    if (this.readOnly) return;
    this.imWriting = true;
    if (this.autoComplete && this.multiSelection && this.acVisible == false) {
      this.onAutocompleteIcoClick('');
      this.hoverIndex = -1;
    }


    return;
    if (this.readOnly) return;
    if (this.autoComplete && !this.multiSelection) {
      if (Array.isArray(this.value) || (!Array.isArray(this.value) && this.value.length > 2)) {
        // GBR 09/01/2024 -- Dovrebbe risolvere il problema in edit del caricamento a vuoto per l'automplete in single selection
        let _ret: Autocomplete = new Autocomplete();
        _ret.field = this.autoCompleteField;
        _ret.object = this.value;
        this.onAutocompleteInputChange.emit(_ret);
        // END GBR 09/01/2024
        //this.showAutocomplete();
      }
    }
  }

  onInputFocusOut(evt: any) {
    return;
    if (!this.multiSelection)
      setTimeout(() => this.onAutocompleteIcoClick(''), 250);
  }

  onInputChange(evt: any) {
    let _value = evt.target.value;
    //this.inputValue = _value;
    if (this.autoComplete) {
      if (this.multiSelection) {
        let _temp: string[] = _value.split(',');
        _value = _temp[_temp.length - 1];
      }
      //if (_value.length > 2){
      let _ret: Autocomplete = new Autocomplete();
      _ret.field = this.autoCompleteField;
      _ret.object = _value;
      this.onAutocompleteInputChange.emit(_ret);
      //this.showAutocomplete();
      // } 

      // Questo se ho cancellato tutti i valori nella input
      //if (_value.length == 0){
      //this.clearAutocompleteSelection = true; //M.M 3.01.24
      //this.autoCompleteDataset = new Array();
      //$("#" + this.autoCompleteId).removeClass("tiac-show-me");
      //if (this.clearAutocompleteSelection) setTimeout(()=> this.clearAutocompleteSelection = false, 250);
      //}
    } else {
      this.onInput.emit(_value);
    }
  }

  onNumericInputChange(evt: any) {
    const value = this.replaceCommasWithDots(evt.target.value);
    if (!this.isValidDecimalDigits(value)) {
      evt.target.value = evt.target.value.length > 1 ? this.lastValidValue : '';
      return;
    }

    if ((value.endsWith('.') == true || value.endsWith(',') == true)) return;
    if (this.isValidNumberInput(value)) {
      this.lastValidValue = value;
      if (this.autoComplete) {
        let _value = value;
        if (this.multiSelection) {
          let _temp: string[] = _value.split(',');
          _value = _temp[_temp.length - 1];
        }
        let _ret: Autocomplete = new Autocomplete();
        _ret.field = this.autoCompleteField;
        _ret.object = _value;
        this.onAutocompleteInputChange.emit(_ret);
      } else {
        if (!this.isMultiOperator) {
          this.onInput.emit(value);
        } else {
          this.betweenToEmit = this.selQueryDirection + "|" + value;
          if (this.selQueryDirection == '') return;
          //this.onInput.emit(this.betweenToEmit);
          this.checkDataAndEmit();
        }
      }
    } else {
      evt.target.value = evt.target.value.length > 1 ? this.lastValidValue : ''; // Revert to last valid value - if typing first character always set empty string
    }
  }

  onNumericFocusOut(evt: any) {
    this.value = this.getValueWithRoudDigits(this.value);
  }

  replaceCommasWithDots(str: string) {
    return str.replaceAll(',', '.');
  }

  private isValidDecimalDigits(value: string): boolean {
    if (!this.limitDecimalDigits || value == null || value == '') return true;

    const decimalSeparatorIndex = value.search(/[.,]/);
    if (decimalSeparatorIndex == -1) return true;

    if (this.roundDigits <= 0) return false;

    const decimalPart = value.substring(decimalSeparatorIndex + 1);
    return decimalPart.length <= this.roundDigits;
  }

  onBetweenNumberChange(evt: any, isFirst: boolean) {
    const value = evt.target.value;
    let _emit: boolean = false;
    if (this.isValidNumberInput(value)) {
      if (this.betweenToEmit == "") {
        this.betweenToEmit = this.selQueryDirection + "|" + (isFirst ? value : '') + "|" + (!isFirst ? value : '');
      } else {
        let _temp: string[] = this.betweenToEmit.split("|");
        _temp[0] = this.selQueryDirection;
        if (isFirst) _temp[1] = value;
        if (!isFirst) _temp[2] = value;
        //if ((_temp[1] != '' && _temp[2] != '') && (parseFloat(_temp[1].toString()) < parseFloat(_temp[2].toString()))) _emit = true;
        this.betweenToEmit = _temp.join("|");
      }
    }
    this.checkDataAndEmit();
    //if (_emit) this.onInput.emit(this.betweenToEmit);
  }

  isValidNumberInput(value: string): boolean {
    //regexNumeric: any = ^[0-9]*\.[0-9]{2}$ or ^[0-9]*\.[0-9][0-9]$;
    let numberRegex: RegExp;
    if (this.allowNegative) {
      numberRegex = new RegExp(String.raw`^-?\d*([.,]?\d{0,100})?$`); // /^-?\d*([.,]?\d{0,2})?$/; // Allow negative numbers with commas or dots as decimal separators
    } else {
      numberRegex = new RegExp(String.raw`^\d*([.,]?\d{0,100})?$`); // Do not allow negative numbers
    }

    return numberRegex.test(value);
  }

  onKeyUpChange(evt: KeyboardEvent) {
    this.onKeyUp.emit(evt);
  }

  onSelectChange(evt: any) {
    this.selectChange.emit(evt.target.selectedOptions[0].value);
  }

  onAutocompleteRowMouseDown(event: MouseEvent) {
    if (!this.preserveFocusOnAutocompleteSelection) return;

    event.preventDefault();
  }

  private focusAutocompleteAnchor() {
    if (!this.preserveFocusOnAutocompleteSelection) return;

    this.inputWrapper?.nativeElement?.focus();
  }

  /**
   * SELECTION FRO AUTOCOMPLETE
   * @param evt 
   * @param i 
   */
  rowClick(event: Event | null, evt: any, hideAutocomplete: boolean) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }

    if (!this.multiSelection) {
      this.selectedRows = new Array();
      this.selectedRows.push(evt);
      let _ret: Autocomplete = new Autocomplete();
      _ret.field = this.autoCompleteField;
      _ret.object = JSON.stringify(evt);
      this.onAutocompleteSelect.emit(_ret);
      this.focusAutocompleteAnchor();
      this.hideAllAutocomplete(); // 13/01/2024
    } else {
      this.preventCloseAutocomplete = false;
      //if (!this.selectedRows) this.selectedRows = new Array();
      if (this.isRowSelected(evt)) {
        //this.deleteValue(this.value[i]);
      } else {
        if (evt)
          this.selectedRows.push(evt)
        let _ret: Autocomplete = new Autocomplete();
        _ret.field = this.autoCompleteField;
        _ret.object = JSON.stringify(this.selectedRows);
        this.onAutocompleteSelectRows.emit(_ret);
      }
    }
  }

  onClickLink(evt: string) {
    this.hideAutocomplete();
    if (evt != '') {
      this.onAutocompleteLinkClick.emit(evt);
    }
  }

  /**
   * DELETE VALUE ONLY FOR MULSTISELECTION
   * @param item 
   */
  deleteValue(item: any) {
    this.preventCloseAutocomplete = true;
    // Remove from Value
    let _temp: any[] = new Array();
    if (!Array.isArray(this.value))
      _temp = this.value.split(',');
    else
      _temp = this.value;

    let _i: number = _temp.findIndex(x => x == item);
    if (_i != -1) {
      this.value = _temp.filter(x => x != item);
    }

    // Delete from SelectedRows
    if (this.value.length == 0) {
      this.selectedRows = new Array();
      this.value = '';
    } else {
      // If I have something in the Selected Rows
      //if (this.selectedRows && this.selectedRows.length > 0) this.f();
      let _x: number = -1;
      if (this.selectedRows && this.selectedRows.length > 0) {
        for (var x = 0; x < this.selectedRows.length; x++) {
          for (const prop in this.selectedRows[x]) {
            if (this.selectedRows[x][prop] == item) {
              _x = x;
              break;
            }
          }
          if (_i != -1) break;
        }
        this.selectedRows.splice(_x, 1);
      }
    }

    // Emit the element to remove value
    let _ret: Autocomplete = new Autocomplete();
    _ret.field = this.autoCompleteField;
    _ret.object = item;
    this.onAutocompleteRemoveElement.emit(_ret);

    // clear the autocomplete input value
    const autoCompleteInput = document.getElementById(this.inputId) as HTMLInputElement | null;
    if (autoCompleteInput && autoCompleteInput.classList.contains('ti-input-ac')) {
      autoCompleteInput.value = '';
    }

    this.preventCloseAutocomplete = false; // MQF: 571 when removing chips, this flag should be false
  }

  onMultiSelectionFocus(evt: any) {
    if (this.autoComplete) {
      this.globalClickService.notifyClick(evt, this);
      this.onAutocompleteIcoClick('');
    }
  }

  trackByIndex(index: number, item: any): number {
    return index;
  }

  onSelectDirection(direction: string) {
    this.selQueryDirection = direction;
    if (this.betweenToEmit == '') return;
    this.checkDataAndEmit();
  }

  checkDataAndEmit() {
    let _temp: string[] = this.betweenToEmit.split("|");
    if (this.selQueryDirection != 'ltgt') {
      if (this.hasUoms && this.selectedUom != '' && this.selectedUom != null && _temp.length == 2)
        _temp.push(this.selectedUom);
      else
        _temp[2] = this.selectedUom;
    } else {
      if (this.hasUoms && this.selectedUom != '' && this.selectedUom != null && _temp.length == 3)
        _temp.push(this.selectedUom);
      else
        _temp[3] = this.selectedUom;
    }


    _temp[0] = this.selQueryDirection;
    let _emit: boolean = false;
    const partValue = (idx: number): string => (_temp[idx] ?? '').toString().trim();
    const parseNumber = (value: string): number => parseFloat(value.replace(',', '.'));
    const hasNumber = (value: string): boolean => value !== '' && !isNaN(parseNumber(value));

    if (!this.hasUoms) {
      const value1 = partValue(1);
      const value2 = partValue(2);
      if (this.selQueryDirection == 'ltgt' && hasNumber(value1) && hasNumber(value2) && (parseNumber(value1) < parseNumber(value2))) _emit = true;
      if (this.selQueryDirection != 'ltgt' && hasNumber(value1)) _emit = true;
    } else {
      const value1 = partValue(1);
      const value2 = partValue(2);
      const uomSingle = partValue(2);
      const uomBetween = partValue(3);
      if (this.selQueryDirection == 'ltgt' && hasNumber(value1) && hasNumber(value2) && (parseNumber(value1) < parseNumber(value2)) && uomBetween != '') _emit = true;
      if (this.selQueryDirection != 'ltgt' && _temp[0] != '' && hasNumber(value1) && uomSingle != '') _emit = true;
    }


    this.betweenToEmit = _temp.join("|");

    if (_emit) {
      //console.log("EMIT " + this,this.betweenToEmit);
      this.onInput.emit(this.betweenToEmit);
    } else if (this.isMultiOperator && this.betweenToEmit != '') {
      // Notify parent grids when a previously valid numeric filter becomes empty/incomplete.
      // The parent removes the active filter and refreshes the OData query.
      this.onInput.emit('');
    }
  }

  onClearDirection() {
    let _elem: any = document.getElementById(this.inputId)!;
    if (_elem) {
      _elem["value"] = '';
    }
    this.value = '';
    this.value1 = '';
    this.value2 = '';
    this.selQueryDirection = '';
    this.betweenToEmit = '';
    this.selectedUom = '';
    this.hasUserSelectedUom = false;
    this.clearValue = true;
    setTimeout(() => {
      this.clearValue = false;
      this.ensureDefaultUomSelection();
    }, 500);

    /* this.clearDataValue();*/
    this.onInput.emit('');
  }

  onSelectedUom(evt: SelectOption) {
    const nextUom = evt?.value != null ? evt.value.toString() : '';
    this.selectedUom = nextUom;
    // Ignore synthetic/empty selections coming from control initialization.
    if (nextUom.trim() != '') {
      this.hasUserSelectedUom = true;
    }
    this.checkDataAndEmit();
    //this.selectedUomChange.emit(this.selectedUom);
  }

  private hasNumericValueInBetweenToEmit(): boolean {
    if (!this.betweenToEmit || this.betweenToEmit.trim() == '') return false;
    const parts = this.betweenToEmit.split('|');
    const value1 = (parts[1] ?? '').toString().trim();
    const value2 = (parts[2] ?? '').toString().trim();
    return value1 != '' || value2 != '';
  }

  private ensureDefaultUomSelection() {
    if (!this.hasUoms || !this.uomOptionList || this.uomOptionList.length == 0) return;

    const currentUom = this.selectedUom != null ? this.selectedUom.toString() : '';
    const currentExists = this.uomOptionList.some(opt => opt?.value != null && opt.value.toString() == currentUom);

    const defaultOption = this.uomOptionList.find(opt =>
      opt?.isDefault === true &&
      opt?.value != null &&
      opt.value.toString().trim() != ''
    );

    // If no numeric payload is set yet, API default must win even if a stale preselection exists.
    const noNumericPayloadYet = !this.hasNumericValueInBetweenToEmit();
    if (defaultOption && (noNumericPayloadYet || !this.hasUserSelectedUom || currentUom == '' || !currentExists)) {
      const nextDefault = defaultOption.value.toString();
      const changed = currentUom != nextDefault;
      this.selectedUom = nextDefault;
      if (changed && this.betweenToEmit != '') {
        this.checkDataAndEmit();
      }
      return;
    }

    if (currentUom != '' && currentExists) return;

    const firstNonEmpty = this.uomOptionList.find(opt => opt?.value != null && opt.value.toString().trim() != '');
    const fallback = this.uomOptionList[0];
    const defaultUom = firstNonEmpty?.value ?? fallback?.value ?? '';
    this.selectedUom = defaultUom;
  }

  getStep(): string {
    if (this.roundDigits == 0) {
      return "0";
    } else {
      let _temp: string = "1";
      for (var x = 1; x <= this.roundDigits; x++) {
        _temp = _temp + "0";
      }
      return (1 / parseInt(_temp)).toString();
    }
  }

  getNumericDisplayValue(value: any): any {
    return this.readOnly ? this.getValueWithRoudDigits(value) : value;
  }

  getValueWithRoudDigits(value: any): string {
    if (value == null || value == undefined || value == '') return value;
    // if (this.imWriting) return value;
    if (this.type == 'number') {
      const parsedValue = parseFloat(value.toString().replace(',', '.'));
      return Number.isFinite(parsedValue) ? parsedValue.toFixed(this.roundDigits) : value;
    } else {
      return value;
    }

  }
}
